import { createAsyncThunk } from '@reduxjs/toolkit';
import { IState } from '../..';
import { httpService } from '../../..';
import { executeApiRequest } from '../../asyncUtils';
import { showFailedRequestDialogThunk } from '../../thunkUtils';
import { uiActionCreators } from '../../ui';
import { logisticsActionCreators } from '../logisticsActionCreators';
import { IShipmentStopNumber } from '../logisticsInterfaces';

export const updateFinalDestination = createAsyncThunk<
  void,
  { loadNumber: string; finalDestinationShipmentId: number },
  { state: IState }
>('logistics/updateFinalDestination', async ({ finalDestinationShipmentId, loadNumber }, { dispatch, getState }) => {
  dispatch(uiActionCreators.showSpinnerDialog());
  const response = await executeApiRequest<IShipmentStopNumber[]>(() =>
    httpService.post(`/Logistics/Loads/${loadNumber}/FinalDestination/${finalDestinationShipmentId}`)
  );

  if (response.requestFailed) {
    showFailedRequestDialogThunk(response, getState(), dispatch);
  } else {
    dispatch(logisticsActionCreators.setFinalDestination({ loadNumber, shipmentId: finalDestinationShipmentId }));

    if (response.value) {
      dispatch(logisticsActionCreators.setShipmentStopNumbers(response.value));
    }
  }

  dispatch(uiActionCreators.hideSpinnerDialog());
});
